import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createDocument } from '../actions'

import { Button, Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { translate } from '../../../common/utils'
import { chunk } from 'lodash'
import { swalError } from '../../../common/components/Swaler'

var animExpand = "-webkit-transition: .1s linear;height:100%;background-color:white;overflow:hidden"
var animColl = "-webkit-transition: .1s linear;height:0px;background-color:white;overflow:hidden"

var initialProperties = {
    name: '',
    surname: '',
    email: '',
    phone: '',
    password: '',
    area: '',
    driver_id: ''
}

class AddDriverBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            properties: initialProperties,
            terminal: '',
            required_properties: ["name", "phone", "password"],
            missing_fields: []
        }
    }

    componentDidMount() {
        if (this.props.toggled == true) {
            this.refs.boxStyle.setAttribute("style", animExpand)
        } else {
            this.refs.boxStyle.setAttribute("style", animColl)
        }

        if (this.props.admin.user.settings && this.props.admin.user.settings.k2enabled == true) {
            var s = { ...this.state }
            s.required_properties.push('k2username')
            s.properties.k2username = ''
            this.setState(s)
        }

    }

    componentDidUpdate() {
        if (this.props.toggled == true) {
            this.refs.boxStyle.setAttribute("style", animExpand)
        } else {
            this.refs.boxStyle.setAttribute("style", animColl)
        }
    }

    onChange = (e) => {
        var state = Object.assign({}, this.state)
        state.properties[e.target.name] = e.target.value

        this.setState(state)
    }

    saveDriver = () => {
        const { toggleAddDriver, admin } = this.props
        const { required_properties, properties, terminal } = this.state
        var fields = required_properties.filter(p => {
            if (this.state.properties[p].length < 1) return true
        })

        if (fields.length) {
            this.setState({ missing_fields: fields })
        } else if (admin.type === 'subadmin' && !terminal) {
            this.setState({ missing_fields: ['terminal'] })
        } else {
            this.props.createDriver({ ...this.state.properties, terminal }).then((data) => {
                if (data.isAxiosError) {
                    swalError(data.response.data.message)
                } else {
                    if (data.message === 'Användarinfo existerar redan!') {
                        swalError('Det går inte att lägga till den här chauffören - kontakta Qlocx i chatten för assistans')
                    } else {
                        toggleAddDriver()
                        this.setState({ properties: initialProperties, terminal: '' })
                    }
                }
            })
        }
    }

    render() {
        const { terminals, admin } = this.props
        const { properties } = this.state

        const chunked = chunk(Object.keys(properties), 3)

        return (
            <div ref="boxStyle">
                <div style={{ padding: "10px" }}>
                    <form>
                        <Grid>
                            {this.state.missing_fields.length ? (<Row><Col><span style={{ color: 'red' }}>Fält måste fyllas i:  {this.state.missing_fields.map(f => translate(f)).join(', ')}</span></Col></Row>) : null}
                            {chunked.map((chunk, i) => {
                                return (<Row key={i * 1337} style={{ marginBottom: '5px' }}>
                                    {chunk.map((val) => {
                                        if (val === 'area' && admin.type === 'c_terminal') return

                                        const shouldShowCountryCode = val === 'phone' && admin.user.countryCode && admin.user.countryCode !== '46'
                                        return (
                                            <div key={val} className="flex">
                                                {shouldShowCountryCode && <span style={{ paddingTop: 5 }}>{`+${admin.user.countryCode}`}</span>}
                                                <input
                                                    key={val}
                                                    name={val}
                                                    className="change-input form-control"
                                                    style={{ width: shouldShowCountryCode ? '270px' : '300px', marginLeft: '5px' }}
                                                    value={this.state.properties[val]}
                                                    placeholder={translate(val) + new String(this.state.required_properties.indexOf(val) > -1 ? ' *' : '')}
                                                    onChange={(e) => this.onChange(e)}
                                                    type="text"
                                                />
                                            </div>
                                        )
                                    })}
                                </Row>)
                            })}
                            {admin.type !== 'c_terminal' && (admin.user.subadmins || admin.type === 'subadmin') && (
                                <>
                                    <h3>{`Åkeri ${admin.type === 'subadmin' ? '*' : ''}`}</h3>
                                    <select onChange={(e) => this.setState({ terminal: e.target.value })}>
                                        {[{ _id: '', company: 'Välj' }].concat(terminals).map((terminal) => (
                                            <option key={terminal._id} value={terminal._id}>{terminal.company}</option>
                                        ))}
                                    </select>
                                </>
                            )}
                            <Row><Col> * Krävs </Col></Row>
                            <br />

                            <Row>
                                <Button onClick={(e) => this.saveDriver()} className="btn btn-primary" bsSize="small" style={{ backgroundColor: "#006e78" }} block><Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara chaufför</Button>
                            </Row>
                        </Grid>

                    </form>
                </div>
            </div>
        )
    }
}

const mapState = (state, props) => {
    return {
        admin: state.collectionData.admin
    }
}

const mapDispatch = (dispatch) => {
    return {
        createDriver: (obj) => dispatch(createDocument('driver', obj))
    }
}

export default connect(mapState, mapDispatch)(AddDriverBox)